import { curry } from 'ramda'

export const normalizeForSearch = (str: string) => str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

export const searchFor = curry((needle, haystack) => normalizeForSearch(haystack).includes(normalizeForSearch(needle)))
